var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.4079 4.5927C20.7984 4.98322 20.7984 5.61639 20.4079 6.00691L6.00789 20.4069C5.61736 20.7974 4.9842 20.7974 4.59367 20.4069C4.20315 20.0164 4.20315 19.3832 4.59367 18.9927L18.9937 4.5927C19.3842 4.20217 20.0174 4.20217 20.4079 4.5927Z",
  fill: "#15A779"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.59367 4.5927C4.9842 4.20217 5.61736 4.20217 6.00789 4.5927L20.4079 18.9927C20.7984 19.3832 20.7984 20.0164 20.4079 20.4069C20.0174 20.7974 19.3842 20.7974 18.9937 20.4069L4.59367 6.00691C4.20315 5.61639 4.20315 4.98322 4.59367 4.5927Z",
  fill: "#15A779"
})));
export default SvgClose;